<script lang="ts" setup>
import type { Form } from "#ui/types";

const props = withDefaults(
    defineProps<{
        title?: string;
        description?: string;
        schema?: any;
        state?: any;
        errors?: any;
        containerClass?: string;
    }>(),
    {
        containerClass:
            "grid grid-cols-1 gap-4 sm:grid-cols-6 p-8 bg-hd-neutral-50 w-full rounded-xl",
    },
);

const emit = defineEmits<{
    (e: "submit", v: SubmitEvent): void;
    (e: "update:form", v: Form<any>): void;
}>();

const form = ref();
watch(form, (to) => emit("update:form", to));

async function onSubmit(event: SubmitEvent) {
    await form.value!.validate();

    emit("submit", event);
}

watch(
    () => props.errors,
    (to) => {
        if (to) {
            form.value.setErrors(
                Array.isArray(to)
                    ? to
                    : Object.entries(to).map(([key, val]) => ({
                          path: key,
                          message: Array.isArray(val) ? val[0] : val,
                      })),
            );
        }
    },
);
</script>

<template>
    <div
        class="grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-8 sm:px-6 lg:grid-cols-3 lg:px-8"
    >
        <div v-if="title || description || $slots.description || $slots.title">
            <h2
                v-if="title || $slots.title"
                class="text-base font-medium font-display leading-7"
            >
                <slot name="title">{{ title }}</slot>
            </h2>
            <p
                v-if="description || $slots.description"
                class="mt-1 text-sm leading-6 text-gray-400"
            >
                <slot name="description">{{ description }}</slot>
            </p>
        </div>
        <UForm
            ref="form"
            :schema="schema"
            :state="state"
            :validate-on="['submit']"
            class="md:col-span-2 rounded-xl"
            @submit="onSubmit"
        >
            <div :class="containerClass">
                <slot
                    :form-group-ui="{
                        wrapper:
                            'space-y-2 [&>label]:sm:grid [&>label]:sm:grid-cols-3 [&>label]:sm:gap-4 [&>label]:sm:space-y-0',
                        label: {
                            wrapper: ``,
                            base: `block text-sm font-medium leading-6 text-gray-900 sm:mt-1.5`,
                            required: `after:content-['*'] after:ms-0.5 after:text-red-500`,
                        },
                        container: 'sm:col-span-2',
                    }"
                />
            </div>
        </UForm>
    </div>
</template>
